// ModalComponent.js
import React, { useRef } from "react";
import "./Modelcss.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { validateMainHall } from "../../shared/Component/BackOffice/Faculty/validateTeachingProgress";
import { AxiosInstance } from "../../axios";
import Swal from "sweetalert2";
import { ImageUrlPrefix } from "../../labels";
import DatePickerSample from "../../shared/Component/DatePicker";
import moment from "moment";
import html2pdf from "html2pdf.js";
function ModelCompontent({ show, showModelData, handleClose, loadListdata, passData }) {
  const [formData, setFormData] = useState({
    examNumber: null,
    hallTicket: null,
    original_mainexam_hallticket: null,
    examDate: "",
  });
  console.log("^^^^^^^^^^^^^^^^^^^^^^", showModelData);

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [htmlContent, setHtmlContent] = useState("");
  const contentRef = useRef();
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "examNumber") {
      // console.log(formData, "formData");
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setError({
        ...error,
        [name]: "",
      });
    } else if (name === "hallTicket" && files && files.length > 0) {
      const gov_hall_ticket = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 3 * 1024 * 1024) {
          const formDataS = new FormData();
          formDataS.append("gov_hall_ticket", gov_hall_ticket);
          AxiosInstance.post("api/upload/", formDataS)
            .then((res) => {
              setFormData({
                ...formData,
                hallTicket: res.data.path,
                original_mainexam_hallticket: res.data.originalname,
              });
              setError({
                ...error,
                hallTicket: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 3MB.";
          setError({
            ...error,
            hallTicket: err,
          });
        }
      } else {
        let err = "pdf files only allowed";
        setError({
          ...error,
          hallTicket: err,
        });
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setError({
        ...error,
        [name]: "",
      });
    }
  };
  const convertUrlsToBase64InHtml = async (html) => {
    const imgUrlRegex = /<img[^>]+src="([^">]+)"/g;
    let match;
    let modifiedHtml = html;

    while ((match = imgUrlRegex.exec(html)) !== null) {
      const url = match[1];
      try {
        const base64 = await convertImageUrlToBase64(url);
        modifiedHtml = modifiedHtml.replace(url, base64);
      } catch (err) {
        // setError(`Failed to convert image URL to Base64: ${url}`);
        console.log("err", url);
      }
    }
    const bgUrlRegex = /background-image:\s*url\(['"]?([^'"\)]+)['"]?\)/g;
    // let match;
    // let modifiedHtml = html;

    while ((match = bgUrlRegex.exec(html)) !== null) {
      const url = match[1];
      try {
        const base64 = await convertImageUrlToBase64(url);
        modifiedHtml = modifiedHtml.replace(url, base64);
      } catch (err) {
        // setError(`Failed to convert image URL to Base64: ${url}`);
        console.log("err", url);
      }
    }

    return modifiedHtml;
  };
  const convertImageUrlToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result); // Base64 string
          };
          reader.onerror = () => {
            reject("Error reading blob as Base64");
          };
          reader.readAsDataURL(blob);
        })
        .catch((err) => {
          reject("err");
        });
    });
  };
  const handleMainHallThicket = (event) => {
    // console.log(formData, "formData.examNumber");
    event.preventDefault();
    const errors = validateMainHall(formData);
    if (Object.keys(errors).length === 0) {
      try {
        console.log(showModelData.user_id, "-------1", showModelData.batch_id, "-----3", showModelData.admission_id, "------4", showModelData.exam_id);

        const dat = {
          main_exam_reg_no: formData.examNumber,
          mainexam_hallticket_filepath: formData.hallTicket,
          original_mainexam_hallticket: formData.original_mainexam_hallticket,
          user_id: showModelData.user_id,
          batch_id: showModelData.batch_id,
          admission_id: showModelData.admission_id,
          exam_id: showModelData.exam_id,
        };
        AxiosInstance.post("api/user/mainExam/add", dat)
          .then((res) => {
            if (res.data.status === true) {
              // const path = res.data.path;
              // if (path) {
                // window.open(path, "_blank");
                const dat = {
                  main_exam_reg_no: "",
                  mainexam_hallticket_filepath: "",
                  original_mainexam_hallticket: "",
                  user_id: showModelData.user_id,
                  batch_id: showModelData.batch_id,
                  admission_id: showModelData.admission_id,
                  exam_id: showModelData.exam_id,
                };
                setIsLoading(true);
                AxiosInstance.post("api/modelexam/create_pdf", dat)
                  .then(async (res) => {
                    const path = res.data;
                    if (path) {
                      const modifiedHtml = await convertUrlsToBase64InHtml(path.path);
                      setHtmlContent(modifiedHtml);
                      setTimeout(() => {
                        setIsLoading(false);
                        const content = contentRef.current;
                        const options = {
                          margin: [0, 0, 0, 0],
                          filename: passData.model_exam_name + ".pdf",
                          image: { type: "jpeg", quality: 0.7 },
                          html2canvas: { width: 2480, scale: 1, dpi: 300 },
                          jsPDF: { unit: "pt", format: "A4", orientation: "portrait" },
                        };
                        html2pdf().from(content.innerHTML).set(options).save();
                      }, 2000);
                    } else {
                      setIsLoading(false);
                      console.log("Something Went Wrong");
                    }
                  })
                  .catch((error) => {
                    setIsLoading(false);
                    return error;
                  });
              // }
              handleClose();
              loadListdata();
            } else {
              Swal.fire({
                title: "Success",
                text: res.data.message,
                icon: "Success",
                confirmButtonText: "Ok",
              });
            }
          })
          .catch((error) => {
            return error;
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(errors);
    }
  };

  return (
    <>
      <div
        ref={contentRef}
        id="html-content"
        style={{ display: "none" }}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      ></div>


      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 class="modal-title modelHallTicketTitle" id="exampleModalLabel">
              Upload Your TNPSC Hall Ticket
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-12 mt-2 mb-2">
                <div className="forms ">
                  <p className="alert_info_ReviewLabel">
                    <strong> NOTE: </strong> Please upload the hall ticket issued
                    by the recruitment board. Only then can you download your
                    AIASA's hall ticket for the model exam.
                  </p>
                </div>
              </div>
              <div className="col-lg-8 col-md-8  mb-3">
                <div className="forms ">
                  <label htmlFor="examNumber" className="form-labels ms-0">
                    Registration Number of the Exam
                  </label>
                  <input
                    type="number"
                    class="Inputss ms-0"
                    value={formData.examNumber}
                    onChange={handleChange}
                    id="examNumber"
                    name="examNumber"
                    placeholder="Registration Number of the Exam"
                  />
                  {error.examNumber && (
                    <p className="errors_main ms-0">{error.examNumber}</p>
                  )}
                </div>
              </div>

              <div className="col-lg-12 col-md-12 mb-3">
                <div className="forms ">
                  <label htmlFor="hallTicket" className="form-labels ms-0">
                    Upload Hall Ticket Issued by the Recruitment Board (In pdf
                    format)
                    {formData.hallTicket !== "" &&
                      formData.hallTicket !== null &&
                      formData.original_mainexam_hallticket !== null && (
                        <a
                          href={`${ImageUrlPrefix}/${formData.hallTicket}`}
                          target="_blank"
                          download
                        >
                          <span className="material-icons align-middle download_icon">
                            file_download
                          </span>
                        </a>
                      )}
                  </label>
                  <div className="row">
                    <div
                      className={
                        formData.hallTicket !== "" && formData.hallTicket !== null
                          ? "col-md-3 "
                          : "col-md-12"
                      }
                    >
                      <input
                        type="file"
                        class={
                          formData.hallTicket !== "" &&
                            formData.hallTicket !== null
                            ? "InputssFile nn_upload_widthHall  ms-0"
                            : "InputssFile  vv_upload_width  ms-0"
                        }
                        onChange={handleChange}
                        id="hallTicket"
                        name="hallTicket"
                        placeholder="Upload Main Exam Hall Ticket"
                      />
                    </div>
                    {formData.hallTicket !== "" &&
                      formData.hallTicket !== null && (
                        <div
                          className={"col-md-9 d-flex align-content-center p-0"}
                        >
                          <span className="nn_upload_file">
                            {formData.hallTicket !== "" &&
                              formData.hallTicket !== null
                              ? formData.original_mainexam_hallticket
                              : ""}
                          </span>
                          <span className="material-icons align-middle text-danger verified_upload">
                            verified
                          </span>
                        </div>
                      )}
                  </div>

                  {error.hallTicket && (
                    <p className="errors_main ms-0">{error.hallTicket}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Link
            data-bs-dismiss="modal"
            onClick={handleClose}
            className="DashboardCancelButton"
          >
            Back to Transaction History
          </Link>
          <button
            type="button"
            className="DashboardButton"
            onClick={handleMainHallThicket}
          >
            <a href="javascript:void(0)">Download AIASA's Hall Ticket</a>
          </button>
        </Modal.Footer>
      </Modal>
    </>

  );
}

export default ModelCompontent;
